import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { BookendHeaderDataType } from 'src/types/bookend';

interface HeaderProps {
  headerData: BookendHeaderDataType;
}

const HeaderInfoContext = createContext<HeaderProps | null>(null);

export const useHeaderInfo = () => {
  const header = useContext(HeaderInfoContext);

  if (!header) {
    throw new Error('useHeaderInfo must be wrapped inside the HeaderProvider');
  }

  return header;
};

interface HeaderInfoProviderProps {
  children: ReactNode | ReactNode[];
  headerData: BookendHeaderDataType;
}

export const HeaderInfoProvider = ({ children, headerData }: HeaderInfoProviderProps) => {
  const value = useMemo(() => {
    return { headerData };
  }, [headerData]);

  return <HeaderInfoContext.Provider value={value}>{children}</HeaderInfoContext.Provider>;
};
